export const en = {
    'switch-to-english': 'Switch to English',
    'switch-to-russian': 'Переключиться на Русский',
    'switch-to-turkish': 'Türkçeye geç'
};
